import React, { useEffect, useState } from "react";
import styled, { useTheme } from "styled-components";

import { useTranslate } from '@tolgee/react';
import Select from "react-select";
import LocalStorage from "../../Helpers/LocalStorage";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";

const CallAudioSettings = ({ videoInputDevice, setSelectedVideoInput, cameraAllowed = true }) => {

  const theme = useTheme()
  const { t } = useTranslate();
  const { selectedMenuVideoInput, setSelectedMenuVideoInput } = useGenericComponentsStateService()
  const selectedCustomStyles = {
    container: (provided) => ({
      ...provided,
      "&:focus-visible": {
        outline: "none",
      },

      fontSize: "14px",
      color: theme.menu.primaryTextColor,

    }),
    control: (provided) => ({
      ...provided,
      "&:focus-visible": {
        outline: "none",
      },
      "&:selected": {
        outline: "none",
      },
      "&:hover": {
        boxShadow: "none",
      },

      boxShadow: "none",
      borderColor: theme.menu.groupContentBackground,
      background: theme.menu.groupContentBackground,
      color: theme.menu.primaryTextColor,
      outline: "none"
    }),
    menuList: (provided) => ({
      ...provided,
      background: theme.menu.groupContentBackground,
      color: theme.menu.primaryTextColor,
    }),
    option: (provided, { isSelected }) => ({
      ...provided,
      "&:hover": {
        background: theme.menu.enterPhoneNumberBackground,
        color: theme.menu.selectedTextColor
      },
      "&:active": {
        background: theme.menu.groupContentBackground
      },
      "&:selected": {
        background: theme.menu.primaryTextColor
      },
      background: isSelected ? theme.menu.selectedTextColor : "inherit"

    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "14px",
      fontWeight: "500",
      color: theme.menu.primaryTextColor,
    }),

  }

  const handleSyncSelectedVideoInput = (deviceId) => {
    let found = videoInputDevice.devices.find(
      (item) => item.deviceId === deviceId
    );
    setSelectedMenuVideoInput(found);
  };

  const handleChangeInputDevice = (deviceId) => {
    videoInputDevice.setActiveMediaDevice(deviceId);
    LocalStorage.setVideoInputDevice(deviceId);
    setSelectedVideoInput(deviceId);
  };

  useEffect(() => {
    handleSyncSelectedVideoInput(videoInputDevice.activeDeviceId);
  }, [videoInputDevice]);

  return (
    <Container>
      {cameraAllowed && (
        <Group>
          <GroupSpan>{t('general.camera')}</GroupSpan>
          <Select
            value={selectedMenuVideoInput}
            onChange={(e) => handleChangeInputDevice(e.deviceId)}
            options={videoInputDevice.devices}
            isSearchable={false}
            isOptionSelected={(e) =>
              videoInputDevice.activeDeviceId === e.deviceId
            }
            styles={selectedCustomStyles}
          ></Select>
        </Group>
      )}
    </Container>
  );
};

export default CallAudioSettings;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 20px;
`;
const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const GroupSpan = styled.p`
  font-size: 16px;
  line-height: 18px;
  font-weight: 500;
  color:${({ theme }) => theme.menu.secondaryTextColor};
`;
